module.exports = __webpack_public_path__ + "img/icon_wy16.09ea7130.png";